import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { TipologicaDTO } from '../../models/tipologica-d-t-o';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';
import { MessageService } from '../../services/message.service';
import { ValidationService } from '../../services/validation.service';

type tipoDepositoComponentOutput = {
	tipologiaDeposito: TipologicaDTO
	, dataRichiesta: Date
};

@Component({
	selector: 'lib-tipologia-deposito',
	templateUrl: './tipologia-deposito.component.html',
	styleUrls: ['./tipologia-deposito.component.css']
})
export class TipologiaDepositoComponent implements OnInit {

	form: FormGroup;

	@Input()
	tipologieDeposito$: Observable<Array<TipologicaDTO>>;

	@Output()
	tipologiaDepositoReady = new EventEmitter<ComponentOutputStatus<tipoDepositoComponentOutput>>();

	tipologiaDeposito: FormControl;
	dataRichiesta: FormControl;
	tipologiaDeposito$: Observable<TipologicaDTO>;
	selectedTipoDeposito: tipoDepositoComponentOutput;
	dateRichiesta = new Date();


	constructor(private msg: MessageService) { }

	ngOnInit(): void {
		this.form = new FormGroup({});

		this.tipologiaDeposito = new FormControl({ value: null, disabled: false },
			[Validators.required]);
		this.form.addControl('tipologiaDeposito', this.tipologiaDeposito);

		this.dataRichiesta = new FormControl({ value: new Date(Date.now()), disabled: true },
			[Validators.required, ValidationService.ValidateDate]
		);
		this.form.addControl("dataRichiesta", this.dataRichiesta);

	}

	compilaRichiesta() {
		this.selectedTipoDeposito = this.depositoReady();
		// console.log('[selectedTipoDeposito]', this.selectedTipoDeposito);
		const depToEmit = ComponentOutputStatus.of(true, this.selectedTipoDeposito);
		this.tipologiaDepositoReady.emit(depToEmit);
	}

	depositoReady(): tipoDepositoComponentOutput {
		return ({
			tipologiaDeposito: this.form.value['tipologiaDeposito']
			, dataRichiesta: new Date(moment(this.dataRichiesta.value, 'DD/MM/YYYY').toDate())
			//TODO
			// , dataRichiesta: new Date(moment(this.form.value['dataRichiesta'], 'DD/MM/YYYY').toDate())
		});
	}
}